import { cbHttp } from "./http.service";

export const recoveryDomain = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recoverdomain`, data);
}

export const recovercheck = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recovercheck`, data);
}
export const recovergetbackup = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recovergetbackup`, data);
}
export const recoversqldata = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recoversqldata`, data);
}
export const recoveruploadbackupcontent = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recoveruploadbackupcontent`, data);
}
export const recovercleanup = async (data: FormData): Promise<string> => {
    return cbHttp.post(`/api/recovery/recovercleanup`, data);
}
